import React from 'react';
import { Box, Button } from '@mui/material';
import RibbonMenuExpandMoreButton from './RibbonMenuExpandMoreButton';
import styles from './RibbonMenuGroup.module.scss';
import RibbonButtonSize from '../RibbonButtonSize';
import type { IRibbonBtnConfig } from '../RibbonConfig';
import { GlobalVariables } from '../../../../pdf/GlobalVariables';
import { useSelector } from 'react-redux';
import {
    eplassSliceListStamps,
    eplassSliceListUserStamps,
    eplassSliceStampName,
} from '../../../../Redux/EplassSlice';
import { GlobalDialogs } from '../../../../pdf/GlobalDialogs';
import type { IStamp, IUserStamp } from '../../../../pdf/Interfaces';
import { ApryseSDK } from '../../../../pdf/ApryseSDK';

export default (props: IRibbonBtnConfig) => {
    const stamps = useSelector(eplassSliceListStamps);
    const userStamps = useSelector(eplassSliceListUserStamps);
    const selectedStamp = useSelector(eplassSliceStampName);

    const stampIcon = React.useMemo(() => {
        let currentSelectedStamp: IStamp | IUserStamp | null = null;
        if (stamps) {
            currentSelectedStamp =
                stamps.filter(stamp => stamp.name === selectedStamp)[0] ?? currentSelectedStamp;
        }
        if (userStamps) {
            currentSelectedStamp =
                userStamps.filter(stamp => stamp.id === selectedStamp)[0] ?? currentSelectedStamp;
        }

        const stampUri = (currentSelectedStamp as unknown as IUserStamp)['id']
            ? `/api/stamps/image/${(currentSelectedStamp as unknown as IUserStamp).id}/72`
            : (currentSelectedStamp as IStamp).preview;

        return (
            <img
                alt={currentSelectedStamp?.name ?? 'stamp'}
                src={stampUri}
                style={{
                    maxHeight: '72px',
                    maxWidth: '100px',
                }}
            />
        );
    }, [selectedStamp]);

    return (
        <Box className={styles.buttonGroup}>
            <Button
                id={GlobalVariables.isForTestRun ? 'rbnMenuBtnCreateStamp' : undefined}
                className={styles.stampButton}
                disabled={!props.config.Enabled}
                onClick={() => {
                    ApryseSDK.setToolMode(ApryseSDK.ToolsENUM.CREATE_STAMP);
                    // ToDO: workaround as the first call gets changed internally in Apryse SDK?
                    setTimeout(() => {
                        ApryseSDK.setToolMode(ApryseSDK.ToolsENUM.CREATE_STAMP);
                    }, 50);
                }}
            >
                {stampIcon}
            </Button>
            <RibbonMenuExpandMoreButton
                key={`btnSelStampDropdownMenu-${props.config.Key}`}
                config={{
                    ...props.config,
                    Callback: () => {
                        GlobalDialogs.showStampDialog();
                    },
                }}
                size={RibbonButtonSize.DropDown}
            />
        </Box>
    );
};
